import { Container, Stack, Typography } from "@mui/material";
import { CommonBgColor } from "shared/constants";
import { componentPageStyles } from "styles/component-page-styles";
import { useTranslation } from "react-i18next";
import { userPreferencesAtom } from "atoms";
import { useAtomValue } from "jotai";
import SSMLDocRenderer from "./SSMLDocRenderer";

export default function SSML() {
  const { t } = useTranslation();
  const userPreferences = useAtomValue(userPreferencesAtom);

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      id="ssml-guide"
      bgcolor={CommonBgColor}
    >
      <Container sx={componentPageStyles.ssml}>
        <Stack gap={2} p={5}>
          <Typography variant="h3">{t("ssml.headline")}</Typography>
          <SSMLDocRenderer
            selectedLanguage={userPreferences?.language || "en"}
          />
        </Stack>
      </Container>
    </Stack>
  );
}
